import { createSlice, createAction } from '@reduxjs/toolkit';
import { getInsight } from './insightsService';
import { insightsApi } from './insightsServiceNew';

const queryRemoved = createAction('insightApi/queries/removeQueryResult');

export const initialState = {
  id: null,
  name: null,
  isLoading: false,
  hasError: false,
  errorStatusCode: null,
};

const insightSlice = createSlice({
  name: 'insight',
  initialState,
  reducers: {
    resetInsight: () => initialState,
    fetchInsightBegan: (state) => ({
      ...state,
      isLoading: true,
      hasError: false,
      errorStatusCode: null,
    }),
    fetchInsightSucceeded: (state, action) => {
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        hasError: false,
        errorStatusCode: null,
      };
    },
    fetchInsightFailed: (state, action) => ({
      ...state,
      isLoading: false,
      hasError: true,
      errorStatusCode: action.payload,
    }),
    setInsightBody: (state, action) => ({
      ...state,
      body: action.payload,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(queryRemoved, (state, action) => {
      if (action.payload.queryCacheKey.includes('getInsight')) {
        return initialState;
      }

      return state;
    });

    builder.addMatcher(
      insightsApi.endpoints.getInsight.matchFulfilled,
      (state, { payload }) => ({ ...state, ...payload })
    );
  },
});
export default insightSlice.reducer;

// Actions
export const {
  resetInsight,
  fetchInsightBegan,
  fetchInsightSucceeded,
  fetchInsightFailed,
  setInsightBody,
} = insightSlice.actions;

// Selectors
export const getInsightId = (state) => state.insight.id;
export const getInsightTitle = (state) => state.insight.title;
export const getInsightLoading = (state) => state.insight.isLoading;
export const getInsightError = (state) => state.insight.hasError;
export const getInsightErrorStatusCode = (state) =>
  state.insight.errorStatusCode;
export const getCurrentInsight = (state) => state.insight;

// Thunks
export const loadInsightThunk =
  (projectId, insightId, versionStatus) => async (dispatch) => {
    try {
      dispatch(fetchInsightBegan());

      const response = await getInsight(projectId, insightId, versionStatus);

      dispatch(fetchInsightSucceeded(response));
    } catch (error) {
      dispatch(
        fetchInsightFailed(error.response ? error.response.status : 500)
      );
    }
  };
